export const BAND_APPROVE_ACTION_VIEW = "band_approve_view";
export const CUSTOMER_ACTION_VIEW = "customer_view";
export const BAND_APPROVE_ACTION_EDIT = "ba_edit";
export const CUSTOMER_ACTION_EDIT = "cs_edit";
export const TIER_3 = "Tier 3";
export const TIER_6 = "Tier 6";
export const TIER_7 = "Tier 7";
